import { WCCContentHelpers } from 'components/content/helpers';
import { DOMHelpers } from 'helpers/dom';
import { IWCCContentBlock, WCCContentBlockType } from '../block/block.interfaces';
import { WCCContentContainerBlock } from '../container/container';

const protectedTags = new Array<string>('a');
const noTrimTags = new Array<string>('b', 'u', 'i');

function isProtectedNode(node: Node) {
    return DOMHelpers.isHTMLElement(node) && protectedTags.includes(node.tagName.toLowerCase());
}

function isNoTrimNode(node: Node) {
    return DOMHelpers.isHTMLElement(node) && noTrimTags.includes(node.tagName.toLowerCase());
}

export interface WCCContentNodeBlockOptions {
    isProtected?: boolean
    noTrim?: boolean
}

export class WCCContentNodeBlock extends WCCContentContainerBlock {
    node: Node

    constructor(sourceNode: Node, blocks?: IWCCContentBlock[], options?: WCCContentNodeBlockOptions) {
        const nodeCopy = sourceNode.cloneNode(true);

        if (blocks == undefined) {
            const childen = [...nodeCopy.childNodes];
            childen.forEach(child => nodeCopy.removeChild(child));

            blocks = childen.map(node => WCCContentHelpers.getBlockFromNode(node, {
                isProtected: options?.isProtected || isProtectedNode(nodeCopy),
                noTrim: options?.noTrim || isNoTrimNode(nodeCopy)
            }));
        }

        super(blocks);

        this.node = nodeCopy;
    }

    protected override getContainer(blocks?: IWCCContentBlock[]) {
        return new WCCContentNodeBlock(this.node, blocks);
    }

    protected override getNodes() {
        const nodeCopy = this.node.cloneNode();
        super.getNodes().forEach(node => nodeCopy.appendChild(node));

        return [nodeCopy];
    }

    protected override getContent() {
        const $container = $(`<div></div>`);
        const $nodeCopy = $(this.node).clone();

        $nodeCopy.html(super.getContent());
        $container.append(<any>$nodeCopy);

        return $container.html();
    }

    protected override getType(): WCCContentBlockType {
        if (DOMHelpers.isHTMLElement(this.node)) {
            const styles = window.getComputedStyle(this.node);

            let display = styles.display;

            if (display == '')
                display = DOMHelpers.getDisplayType(this.node);

            if (display == 'inline' || display == 'inline-flex')
                return 'inline-container';
        }

        return super.getType();
    }
}